<div class="contenedor" style="text-align: center; border-radius: 20px;">
    <img class="logo" style="border-radius: 20px;" src="../../../../../assets/images/logos/Cargando.gif" alt="GIF cargando">
</div>
